import { Program, ProgramDate } from '../../types'
import { formatDate, getResource } from '../../utils'
import { RecordDot, RecordDots } from './record-dots'

export const ProgramHeader = ({
  channelTitle,
  programTitle,
  start,
  end,
  userRecording,
  nextProgram,
  previousProgram,
  onProgramClick,
}: {
  channelTitle: string
  programTitle: string
  start: ProgramDate
  end: ProgramDate
  userRecording: 'once' | 'everyday' | 'none'
  nextProgram: Program | undefined
  previousProgram: Program | undefined
  onProgramClick: (id: number | undefined) => void
}) => {
  const today = new Date().toISOString().slice(0, 10)
  const isProgramToday = start.utc.startsWith(today)

  return (
    <div className="program-drawer-header">
      <div className="title-container">
        {previousProgram && (
          <button
            className="program-navigation-icon icon-seta-left previous"
            onClick={() => onProgramClick(previousProgram.id)}
            type="button"
          >
            <span className="screen-readers-only">
              {getResource('Program.Previous')}
            </span>
          </button>
        )}
        <span className="program-title no-translate">
          {programTitle}
          {userRecording === 'everyday' && <RecordDots />}
          {userRecording === 'once' && <RecordDot />}
        </span>
        {nextProgram && (
          <button
            className="program-navigation-icon icon-seta-right next"
            onClick={() => onProgramClick(nextProgram.id)}
            type="button"
          >
            <span className="screen-readers-only">
              {getResource('Program.Next')}
            </span>
          </button>
        )}
      </div>
      <div className="channel-info">
        <span className="channel-name no-translate">{channelTitle}</span>
        <span className="program-date">
          <span>
            {isProgramToday
              ? getResource('Program.Drawer.Today')
              : formatDate(start.date)}
            , {start.time} - {end.time}
          </span>
        </span>
      </div>
    </div>
  )
}
